'use client';

import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';

import SmartInLine from '@/components/shared/components/smart-offers/inline';
import SmartPopUP from '@/components/shared/components/smart-offers/pop-up';
import { useGetSmartOffer } from '@/components/shared/components/smart-offers/services/hooks';
import SmartSideIn from '@/components/shared/components/smart-offers/side-in';

import { useSmartOfferStore } from '@/store/smart-offer.store';

import { SMART_OFFER_TYPES } from '@/models/smart-offer.model';

export default function SmartOffer() {
  const pathname = usePathname();
  const { currentPathname, setShowSmartOffer, setShowInLineSmartOffer, showSmartOffer } =
    useSmartOfferStore();
  const [showSideIn, setShowSideIn] = useState(false);
  const [showPopUp, setShowPopUp] = useState(false);
  const [showInLine, setShowInLine] = useState(false);
  const [isAfterLogin, setIsAfterLogin] = useState(false);
  const param = isAfterLogin ? '/after-login' : pathname;
  const { refetch, data } = useGetSmartOffer(param);
  useEffect(() => {
    if (pathname === currentPathname && currentPathname !== null) {
      setIsAfterLogin(true);
    } else {
      setIsAfterLogin(false);
    }
  }, [pathname, currentPathname]);

  useEffect(() => {
    refetch();
  }, [param]);

  useEffect(() => {
    if (data && (!Array.isArray(data) || data.length > 0)) {
      setShowSmartOffer(true);

      if (data?.displayType === SMART_OFFER_TYPES.SIDE_IN) {
        setShowSideIn(true);
      } else if (data?.displayType === SMART_OFFER_TYPES.POP_UP) {
        setShowPopUp(true);
      } else if (data?.displayType === SMART_OFFER_TYPES.IN_LINE) {
        setShowInLineSmartOffer(true);
        setShowInLine(true);
      }
    } else {
      setShowSideIn(false);
      setShowPopUp(false);
      setShowInLine(false);
      setShowSmartOffer(false);
      setShowInLineSmartOffer(false);
    }
  }, [data]);
  if (showSideIn) {
    return <SmartSideIn data={data} />;
  } else if (showPopUp) {
    return <SmartPopUP data={data} />;
  } else if (showInLine) {
    return <SmartInLine data={data} />;
  } else {
    return null;
  }
}
